import { useNavigate, Link as RouterLink } from 'react-router-dom'
import {
  Avatar,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

import { LinkIcon } from 'src/assets/icons'
import { TableRelationIcon } from 'src/components/table-relation-icon'
import { TableDescriptionColumn } from './table-description-column.component'

import { IImpactLibraryDtoWithId } from 'src/types'
import { useStyles } from './styles'
import { Fragment } from 'react'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface ITableListProps {
  items?: IImpactLibraryDtoWithId[] | void
}

const TableList = ({ items }: ITableListProps) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleSelect = (id: string) => () => {
    navigate(`add?libraryDuplicate=${id}`)
  }

  return (
    <TableContainer sx={{ minWidth: '660px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" />
            <TableCell align="center">
              <HelperWrapper t="impact-periods-name-column" />
            </TableCell>
            <TableCell align="center">
              <HelperWrapper t="un-sdg-title-abbr" />
            </TableCell>
            <TableCell align="center" />
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((row) => (
            <Fragment key={row.id}>
              <TableRow className={classes.tableRow}>
                <TableCell>
                  <Avatar alt={row.name} src={row.image_small || row.image} />
                </TableCell>
                <TableCell>
                  {row.name}
                  {row.url && (
                    <>
                      <br />
                      <Link
                        className={classes.rowUrlLink}
                        target="_blank"
                        component={RouterLink}
                        to={row.url}
                      >
                        <HelperWrapper t="account-form-website-input-label" />
                        <LinkIcon className={classes.urlIcon} />
                      </Link>
                    </>
                  )}
                </TableCell>
                <TableCell>
                  <div className={classes.selectionWrapper}>
                    {row.un_sdg.map((unSdg) => {
                      return (
                        <TableRelationIcon
                          iconsInARow={2}
                          key={unSdg.id}
                          iconAlt={unSdg.name}
                          icon={unSdg.image_small || unSdg.image}
                          title={unSdg.name}
                          isSquared
                        />
                      )
                    })}
                  </div>
                </TableCell>
                <TableCell align="right">
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    className={classes.impactsLibraryButton}
                    onClick={handleSelect(row.id)}
                  >
                    <HelperWrapper t="select-button-text" />
                  </Button>
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRow}>
                <TableCell colSpan={4}>
                  <TableDescriptionColumn text={row.description} />
                </TableCell>
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export { TableList }
